import type { Effect, SoloRunState, Track } from '../types.js';

export function applyEffects(state: SoloRunState, effects: Effect[]): SoloRunState {
  let next = { ...state, tracks: { ...state.tracks }, variables: { ...state.variables } };

  for (const effect of effects) {
    switch (effect.type) {
      case 'set_variable':
        next.variables[effect.target] = effect.value;
        break;
      case 'shift_track': {
        const t = effect.target as Track;
        next.tracks[t] = (next.tracks[t] ?? 0) + effect.value;
        break;
      }
      case 'shift_dread':
        next.dread = Math.max(0, Math.min(10, next.dread + effect.value));
        break;
      case 'add_callback':
        next.callbacks = { ...next.callbacks, [effect.target]: effect.value };
        break;
      case 'apply_keepsake':
        next.keepsakes = { ...next.keepsakes, [effect.target]: effect.value };
        break;
      case 'narrator_glitch':
        next.narratorGlitchActive = true;
        break;
      case 'scene_mood':
        next.sceneMood = effect.value;
        break;
      case 'grant_energy':
        next.energy = Math.min(next.maxEnergy, next.energy + effect.value);
        break;
      default:
        break;
    }
  }

  return next;
}
